var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"f-w-bold small-4"},[_c('span',{staticClass:"badge c-bright f-w-bold",class:_vm.cssClasses},[_vm._v("\n        "+_vm._s(_vm.status.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }